// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-25T15:49:53.071Z
// Property: Sierra Glen (ID: 6767906449166906)
// Collections: 17 amenities, 4 floorplans (live), 31 photos, 33 POIs, 1 reviews, 6 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166906",
  "property_external_id": "495831",
  "property_zillow_url": "https://www.zillow.com/homedetails/7321-Auburn-Oaks-Ct-Citrus-Heights-CA-95621/300342419_zpid/",
  "property_apartments_url": "https://www.apartments.com/sierra-glen-citrus-heights-ca/2qcf218/",
  "property_google_business_url": "https://www.google.com/maps/place/Sierra+Glen+Apartments/data=!4m2!3m1!1s0x0:0x5c136bcb4c9d7748?sa=X&ved=2ahUKEwjc_qbEl7ySAxV0avUHHX9iCYEQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495831 p0505499",
  "property_status": null,
  "property_slug": "sierra-glen",
  "property_name": "Sierra Glen",
  "property_website_url": "www.citrusheightscaliforniapartments.com",
  "property_domain": "https://www.citrusheightscaliforniapartments.com/",
  "property_address": "7321 Auburn Oaks Court",
  "property_full_address": "7321 Auburn Oaks Court, Citrus Heights, CA, 95621",
  "property_address_1": "7321 Auburn Oaks Court",
  "property_address_2": null,
  "property_address_city": "Citrus Heights",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95621",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "Outer Carmichael/Citrus Heights",
  "property_address_latitude": "38.7188",
  "property_address_longitude": "-121.2927",
  "property_email": "sierraglen@ctlmanagement.com",
  "property_phone": "(279) 202-9643",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Sierra Glen in Citrus Heights, CA—where comfort meets convenience. Choose from stylish studio, one, or two-bedroom floor plans, featuring walk-in closets, cozy fireplaces, and high-speed internet. Enjoy our inviting pool, relaxing spa, and essential amenities to elevate your living experience. Start your journey to a new home today!",
  "property_long_description": "Welcome to Sierra Glen, your ideal oasis nestled in the heart of Citrus Heights, CA. Our thoughtfully designed apartment community offers a variety of floor plans, including cozy studios, spacious one-bedroom units, and welcoming two-bedroom homes—all tailored to meet your lifestyle needs. Each apartment features modern conveniences like high-speed internet access, walk-in closets, and inviting fireplaces, ensuring your comfort is our top priority.\n\nAt Sierra Glen, we elevate your living experience with an array of exceptional amenities. Dive into relaxation at our sparkling pool or unwind in our rejuvenating spa. Enjoy the convenience of on-site laundry facilities and online services that simplify your day-to-day life. Whether you prefer the charm of walk-up living or the tranquil ambiance of smoke-free settings, you’ll find just what you’re looking for here.\n\nPerfectly located in Citrus Heights, Sierra Glen provides easy access to nearby shopping, dining, and recreational opportunities, making it one of the most sought-after communities in the area. Our dedicated team is committed to helping you find your perfect home, so you can truly enjoy all that our community has to offer.\n\nDon’t wait to experience the Sierra Glen lifestyle! Find your new home today—browse our availability or schedule a tour to explore all the features that make our community exceptional. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a0adba-4d2d-708d-a816-bad8b1637080.webp",
  "property_featured_image_media": {
    "alt_text": "A sparkling blue swimming pool surrounded by lounge chairs and umbrellas, with apartment buildings in the background.",
    "public_id": "01a0adba-4d2d-708d-a816-bad8b1637080",
    "storage_key": "property/6767906449166906/01a0adba-4d2d-708d-a816-bad8b1637080.webp",
    "width": 2560,
    "height": 1709
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "168",
  "property_year_built": "1987",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.42857142857143",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://citrusheightscaliforniapartments.securecafe.com/onlineleasing/sierra-glen-0/floorplans.aspx",
  "property_resident_portal_url": "https://citrusheightscaliforniapartments.securecafe.com/residentservices/sierra-glen-0/userlogin.aspx",
  "property_apply_now_url": "https://citrusheightscaliforniapartments.securecafe.com/onlineleasing/sierra-glen-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d7408-376b-75fd-afaf-f55f4896c81e.webp",
  "property_primary_logo_media": {
    "alt_text": "Sierra Glen Apartments logo",
    "public_id": "019d7408-376b-75fd-afaf-f55f4896c81e",
    "storage_key": "property/6767906449166906/019d7408-376b-75fd-afaf-f55f4896c81e.webp",
    "width": 526,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d7408-3791-73e9-bbe6-7769836519b1.webp",
  "property_secondary_logo_media": {
    "alt_text": "Sierra Glen Apartments logo",
    "public_id": "019d7408-3791-73e9-bbe6-7769836519b1",
    "storage_key": "property/6767906449166906/019d7408-3791-73e9-bbe6-7769836519b1.webp",
    "width": 526,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019de0b2-7b2b-72f2-812b-24d6299779ae.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sierra Glen Apartments logo",
    "public_id": "019de0b2-7b2b-72f2-812b-24d6299779ae",
    "storage_key": "property/6767906449166906/019de0b2-7b2b-72f2-812b-24d6299779ae.webp",
    "width": 526,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019de0b2-6ed6-738d-a86c-948f2d085bc8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sierra Glen Apartments logo.",
    "public_id": "019de0b2-6ed6-738d-a86c-948f2d085bc8",
    "storage_key": "property/6767906449166906/019de0b2-6ed6-738d-a86c-948f2d085bc8.webp",
    "width": 526,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "420 - 834",
  "property_sqft_min": "420",
  "property_sqft_max": "834",
  "property_price_range": "1215 - 2695",
  "property_price_min": "1215",
  "property_price_max": "2695",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/SierraGlenApartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJBQ2z0onfmoARSHedTMtrE1w",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Citrus+Heights%2C+CA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sierra Glen",
  "property_home_romance_title": "Embrace the Comfort of Your New Dream Home Today",
  "property_home_amenities_blurb": "Welcome to Sierra Glen in Citrus Heights, where modern comforts meet serene living. Choose from our inviting studio, one-bedroom, or two-bedroom floor plans. Unwind at the pool, enjoy high-speed internet, or relax in your spacious walk-in closet. Your perfect sanctuary awaits—come experience the essence of community living!",
  "property_home_floorplans_blurb": "Welcome to Sierra Glen, where modern living meets serene surroundings in Citrus Heights, CA. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious layouts and contemporary finishes. Dive into your future home and find the perfect space that complements your unique rhythm. Browse our available apartment homes today!",
  "property_home_gallery_blurb": "Welcome to Sierra Glen in Citrus Heights, CA, where modern living meets comfort. Choose from our stylish studios, inviting one, or spacious two-bedroom floor plans. Enjoy amenities like a refreshing pool, a serene spa, and convenient laundry facilities. Picture yourself living here, enveloped in relaxation and community charm!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Citrus Heights, Sierra Glen offers more than just stylish studio, one, and two-bedroom apartments; it’s a gateway to vibrant local attractions. From the serene Maidu Regional Park to the engaging Aerospace Museum, your new home places an exciting lifestyle at your doorstep. See what's around our community!",
  "property_home_reviews_blurb": "Nestled in the heart of Citrus Heights, Sierra Glen offers a vibrant community where comfort meets convenience. Residents rave, “The friendly atmosphere and amenities make it feel like home.” Join a place where connections flourish and life unfolds beautifully. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Sierra Glen in Citrus Heights, vibrant living meets endless adventure. Enjoy nearby treasures like the Aerospace Museum of California, Maidu Museum, and scenic parks like Rusch Community Park. With fitness centers galore and convenient access to American River College, your ideal lifestyle awaits right outside your door. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sierra Glen in Citrus Heights, CA, modern living meets comfort. Choose from our stylish studios, one, or two-bedroom apartments, each designed for relaxation and convenience. Enjoy our inviting pool, on-site laundry, and serene spa, all complemented by high-speed internet and cozy fireplaces for a home that truly elevates your lifestyle.",
  "property_applynow_blurb": "Welcome to Sierra Glen in Citrus Heights, CA, where modern comforts meet serene living. Choose from spacious studio, one, or two-bedroom floor plans. Enjoy amenities like a sparkling pool, soothing spa, and high-speed internet—all in a smoke-free environment. Find your new home and lease online today!",
  "property_contactus_blurb": "At Sierra Glen in Citrus Heights, CA, choose from a variety of thoughtfully designed floor plans, including studios, one-bedroom, and two-bedroom apartments to fit your lifestyle. Have questions about our vibrant community? Reach out to our friendly leasing team today for personalized assistance! Your new home awaits at Sierra Glen.",
  "property_faqs_blurb": "At Sierra Glen in Citrus Heights, CA, we cater to diverse lifestyles with thoughtfully designed studio, one-bedroom, and two-bedroom floor plans. Curious about our community? Our FAQs page offers valuable insights and answers to your pressing questions, ensuring you feel right at home. Don’t miss out—browse now!",
  "property_floorplans_blurb": "At Sierra Glen in Citrus Heights, CA, each floor plan is thoughtfully designed to elevate your living experience. Choose from cozy studios to spacious one- and two-bedroom layouts, tailored for comfort and style. Browse our available apartment homes to discover the perfect fit for your lifestyle today!",
  "property_gallery_blurb": "At Sierra Glen in Citrus Heights, CA, vibrant living meets comfort and style. Choose from our thoughtfully designed studio, one, or two-bedroom apartments. Indulge in amenities like a sparkling pool, spa, and cozy fireplaces. Picture yourself here, where each day feels like a retreat—your ideal home awaits!",
  "property_interactivemap_blurb": "Nestled in the heart of Citrus Heights, Sierra Glen invites you to find your perfect abode among our diverse floor plans—from cozy studios to spacious two-bedrooms. Unwind by the pool or pamper yourself in the spa. Connect with your new community using our interactive map to discover your dream home today!",
  "property_pets_blurb": "At Sierra Glen in Citrus Heights, your furry friends will feel right at home! With spacious units for cats and dogs up to 25 lbs, plus a haven for small caged animals, we celebrate a pet-friendly lifestyle. Enjoy $30 monthly pet rent for each beloved companion in our vibrant community.",
  "property_referafriend_blurb": "At Sierra Glen in Citrus Heights, CA, life's best moments are shared. With versatile floor plans—from cozy studios to spacious two-bedrooms—you'll find the perfect space for you and your friends. Great friends make great neighbors, so refer a friend to our vibrant community today and enhance your living experience!",
  "property_residentaccess_blurb": "Welcome to Sierra Glen in Citrus Heights, CA, where your ideal living space awaits! Choose from our stylish studio, spacious one-bedroom, or family-friendly two-bedroom floor plans. Empower your experience with effortless online access—log in to your resident portal for rent payments, maintenance requests, and more. Your community, your convenience!",
  "property_reviews_blurb": "At Sierra Glen in Citrus Heights, residents rave about the welcoming atmosphere and stunning amenities. One resident shares, \"Living here feels like home,\" highlighting the community spirit that defines our apartments. Curious about their experiences? See what our residents have to say about living at our community!",
  "property_created_at": "1762785114776",
  "property_scheduletour_blurb": "Experience the charm of Sierra Glen in Citrus Heights, CA, where diverse floor plans—from cozy studios to spacious two-bedrooms—await. Schedule a tour today and envision your new home among a vibrant community. Curious about resident life? Check out their testimonials and see why Sierra Glen feels like home.",
  "property_thankyou_blurb": "Thank you for reaching out to Sierra Glen! Nestled in vibrant Citrus Heights, our community offers thoughtfully designed studio, one-bedroom, and two-bedroom apartment floor plans. Your journey to comfortable living begins here, and our team is excited to connect with you soon to answer any questions you may have!",
  "property_virtualtours_blurb": "Welcome to Sierra Glen in sunny Citrus Heights, CA, where modern living meets comfort. With versatile floor plans, including charming studios and spacious one- and two-bedroom apartments, your perfect home awaits. Experience the beauty of our community from the comfort of your own device—take the virtual tour today!",
  "property_copyright": "2025 All Rights Reserved. Sierra Glen",
  "property_seo_title_home": "Sierra Glen |  Apartments in Citrus Heights, CA",
  "property_seo_description_home": "Experience the charm of Sierra Glen in Citrus Heights, CA. Enjoy spacious floor plans, modern amenities, and a smoke-free lifestyle. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Citrus Heights, CA Apartments for Rent",
  "property_seo_description_floorplans": "Unlock your ideal lifestyle at Sierra Glen, Citrus Heights! Choose from stylish studios, spacious one and two-bedroom homes. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Citrus Heights, CA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Sierra Glen in Citrus Heights, CA. Enjoy a pool, spa, and modern amenities like high-speed internet and walk-in closets. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Citrus Heights, CA",
  "property_seo_description_gallery": "Picture life at Sierra Glen in Citrus Heights! Enjoy stunning apartments with pools, spas, spacious floor plans, and modern amenities in a smoke-free haven.",
  "property_seo_title_virtualtours": "Virtual Tours | Sierra Glen Apartments",
  "property_seo_description_virtualtours": "Step inside Sierra Glen, Citrus Heights' vibrant community! Enjoy studio, one, and two-bedroom floor plans. Take our virtual tour and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Sierra Glen Apartments",
  "property_seo_description_interactivemap": "Find your perfect oasis at Sierra Glen in Citrus Heights, CA! Use our interactive map to browse studio to two-bedroom homes with resort-style amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Citrus Heights, CA",
  "property_seo_description_neighborhood": "Uncover the charm of Citrus Heights near Sierra Glen! Dive into local favorites and hidden gems just steps from our studios, one, and two-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | Sierra Glen",
  "property_seo_description_contact": "Connect with Sierra Glen in Citrus Heights! From cozy studios to spacious two-bedrooms, our leasing team is ready to answer your questions. Reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Citrus Heights, CA",
  "property_seo_description_faqs": "Find answers to your questions about Sierra Glen in Citrus Heights. Learn about our spacious floor plans, amenities like a pool, spa, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Citrus Heights, CA",
  "property_seo_description_reviews": "Experience the charm of Sierra Glen in Citrus Heights, CA. Read resident reviews and learn about our studios, spacious layouts, and top-notch amenities today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Citrus Heights, CA",
  "property_seo_description_applynow": "At Sierra Glen in Citrus Heights, CA, enjoy stylish studios to spacious two-bedrooms with premium amenities. Apply online now and embrace your new lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Sierra Glen",
  "property_seo_description_residentaccess": "Secure your comfort at Sierra Glen! Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Citrus Heights, CA.",
  "property_seo_title_referafriend": "Refer A Friend | Sierra Glen",
  "property_seo_description_referafriend": "Refer a friend to Sierra Glen in Citrus Heights! Together, enjoy a vibrant community and great amenities. Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sierra Glen",
  "property_seo_description_scheduletour": "Experience the charm of Sierra Glen in Citrus Heights, CA. Schedule your tour today and uncover your dream apartment nestled in beautiful surroundings!",
  "property_seo_title_privacy": "Privacy Policy | Sierra Glen",
  "property_seo_description_privacy": "At Sierra Glen, your privacy is our priority. Discover how we protect your info while you enjoy life in Citrus Heights, CA. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Sierra Glen",
  "property_seo_description_accessibility": "Sierra Glen in Citrus Heights champions digital inclusion, ensuring everyone feels at home both online and offline.",
  "property_seo_title_sitemap": "Sitemap | Sierra Glen",
  "property_seo_description_sitemap": "Navigate your future home at Sierra Glen in Citrus Heights, CA. Find everything you need to make the most of our vibrant community—check out our sitemap!",
  "property_seo_title_thankyou": "Thank You | Sierra Glen",
  "property_seo_description_thankyou": "Thank you for reaching out to Sierra Glen in Citrus Heights! A team member will connect with you soon to assist with your future home. Exciting times ahead!",
  "property_seo_title_pets": "Pet Policy | Apartments in Citrus Heights, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789621072775",
  "amenities": [
    {
      "id": "ec_bce13d190131b43a28eab842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429415",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-5113-765d-a6f8-718f150f3df5.webp",
      "amenity_image_media": {
        "alt_text": "Apartment complex swimming pool and hot tub with lounge chairs and tables.",
        "public_id": "01a08a0a-5113-765d-a6f8-718f150f3df5",
        "storage_key": "property/6767906449166906/01a08a0a-5113-765d-a6f8-718f150f3df5.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A large swimming pool with a shaded area next to it at Sierra Glen Apartments, California, 95621,A swimming pool surrounded by lounge chairs and trees at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbb4c61077070ed8cb29aef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429414",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-4880-75db-bc49-62fccf410f22.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
        "public_id": "01a08a0a-4880-75db-bc49-62fccf410f22",
        "storage_key": "property/6767906449166906/01a08a0a-4880-75db-bc49-62fccf410f22.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A hot tub sits in the middle of a pool area with a building in the background at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51ac5cb0c776148b32599f16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429410",
      "title": "24-Hour Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-2d7e-76e1-b2d2-31c24a57794f.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019d1c09-2d7e-76e1-b2d2-31c24a57794f",
        "storage_key": "property/6767906449166906/019d1c09-2d7e-76e1-b2d2-31c24a57794f.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Sierra Glen Laundry Care Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb3b9a8282e76559c00fd90b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "86455579",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad910aec3a4f48e9574068ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "86455581",
      "title": "Complimentary Wi-Fi In Pool Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3348398f10ceab2daf82fc08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "122195808",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-30ac-722c-a2ed-46156ef1ccd3.webp",
      "amenity_image_media": {
        "alt_text": "Amazon package locker system outside apartment building.",
        "public_id": "01a08a0a-30ac-722c-a2ed-46156ef1ccd3",
        "storage_key": "property/6767906449166906/01a08a0a-30ac-722c-a2ed-46156ef1ccd3.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "24 hour package lockers at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa8c655687bcceeb1b8a7a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "86455580",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a94f53c11870888a0d9eef2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "86455582",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b757f012c2fe8cbdec403d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429412",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b24d561f0816f2fffdd4c4ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "82390259",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f52f546d1705338a9870bff8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "82390261",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_147721cd862c4f77f08fc2c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "86455583",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca0703d576f7644e76e2b037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429418",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b8f548bca950dd8fc187b12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429419",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-32b4-701b-ad29-d6fdcfab96fd.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, sofa, armchair, coffee table, and artwork.",
        "public_id": "01a08a0a-32b4-701b-ad29-d6fdcfab96fd",
        "storage_key": "property/6767906449166906/01a08a0a-32b4-701b-ad29-d6fdcfab96fd.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A living room with a grey couch, a wooden coffee table, and a painting on the wall at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c3a60a8cb492097c02c530e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "87311304",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-35be-71dd-b2c7-b7c259cb9357.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area with breakfast bar and seating.",
        "public_id": "01a08a0a-35be-71dd-b2c7-b7c259cb9357",
        "storage_key": "property/6767906449166906/01a08a0a-35be-71dd-b2c7-b7c259cb9357.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A kitchen with a table set for four at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_193b2eec0d6dfc6df770deb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "80429417",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a09-f16f-74ce-8072-7194ba17b2ff.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, white appliances, and a double sink.",
        "public_id": "01a08a09-f16f-74ce-8072-7194ba17b2ff",
        "storage_key": "property/6767906449166906/01a08a09-f16f-74ce-8072-7194ba17b2ff.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "A kitchen with a white stove and brown cabinets at Sierra Glen Apartments, California, 95621",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f57478261145907b39f251c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "yardi",
      "external_id": "87311967",
      "title": "Walk-In Closet - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1213fccbbd45a74c0b1986c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a09-f16f-74ce-8072-7194ba17b2ff.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, white appliances, and a double sink.",
        "public_id": "01a08a09-f16f-74ce-8072-7194ba17b2ff",
        "storage_key": "property/6767906449166906/01a08a09-f16f-74ce-8072-7194ba17b2ff.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, granite countertops, and a spacious double sink. Perfect for preparing meals and entertaining guests.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, white appliances, and a double sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelKitchen.jpg"
    },
    {
      "id": "ec_28b64b30fc2dd5a348602b75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-35be-71dd-b2c7-b7c259cb9357.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with breakfast bar and seating.",
        "public_id": "01a08a0a-35be-71dd-b2c7-b7c259cb9357",
        "storage_key": "property/6767906449166906/01a08a0a-35be-71dd-b2c7-b7c259cb9357.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy a spacious kitchen and dining area, perfect for meals and entertaining. Features include a breakfast bar and comfortable seating.",
      "link": "false",
      "alt_text": "Kitchen and dining area with breakfast bar and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelDining.jpg"
    },
    {
      "id": "ec_ae2c87b640863a62a39a727d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-b258-73c1-a9b0-f6dfba17b3f8.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and dining area with table and chairs.",
        "public_id": "01a08a0a-b258-73c1-a9b0-f6dfba17b3f8",
        "storage_key": "property/6767906449166906/01a08a0a-b258-73c1-a9b0-f6dfba17b3f8.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A spacious and inviting living and dining area, perfect for relaxing and entertaining. Features comfortable seating and a well-appointed dining space.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, coffee table, and dining area with table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelDiningLivingRoom.jpg"
    },
    {
      "id": "ec_fa05f3c1b608661ed8b7cd9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-8da3-7042-af4c-745c6f8ea0a9.webp",
      "image_media": {
        "alt_text": "Spacious living room with a gray sofa, armchair, coffee table, and fireplace.",
        "public_id": "01a08a0a-8da3-7042-af4c-745c6f8ea0a9",
        "storage_key": "property/6767906449166906/01a08a0a-8da3-7042-af4c-745c6f8ea0a9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living room, featuring a cozy fireplace and ample seating.",
      "link": "false",
      "alt_text": "Spacious living room with a gray sofa, armchair, coffee table, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelLivingRoom.jpg"
    },
    {
      "id": "ec_21802b39c96b1f5435fdfb43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-32b4-701b-ad29-d6fdcfab96fd.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, armchair, coffee table, and artwork.",
        "public_id": "01a08a0a-32b4-701b-ad29-d6fdcfab96fd",
        "storage_key": "property/6767906449166906/01a08a0a-32b4-701b-ad29-d6fdcfab96fd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating including a sofa and armchair, a stylish coffee table, and decorative wall art. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with fireplace, sofa, armchair, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_7a837090dec0c19a454c225e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-9ce5-756a-ad13-7811e51082a1.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, wooden nightstands, and lamps.",
        "public_id": "01a08a0a-9ce5-756a-ad13-7811e51082a1",
        "storage_key": "property/6767906449166906/01a08a0a-9ce5-756a-ad13-7811e51082a1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and stylish wooden nightstands with ambient lighting.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, wooden nightstands, and lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelBedroomBathroom.jpg"
    },
    {
      "id": "ec_e191952ddb8e447409430d3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-8ec5-746b-bb9b-b1928a300bed.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser and mirror, a bed with white linens, and a window with sheer curtains.",
        "public_id": "01a08a0a-8ec5-746b-bb9b-b1928a300bed",
        "storage_key": "property/6767906449166906/01a08a0a-8ec5-746b-bb9b-b1928a300bed.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a large dresser with a mirror, a comfortable bed, and ample natural light from the window.",
      "link": "false",
      "alt_text": "Bedroom with a dresser and mirror, a bed with white linens, and a window with sheer curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelBedroom.jpg"
    },
    {
      "id": "ec_d8a06a0026f3fe5fc074431c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-912d-76e6-9f56-39d4596086e3.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "01a08a0a-912d-76e6-9f56-39d4596086e3",
        "storage_key": "property/6767906449166906/01a08a0a-912d-76e6-9f56-39d4596086e3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, stylish nightstand, and a large window with natural light.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ModelBedroomWindow.jpg"
    },
    {
      "id": "ec_c7077c86c8923a89d087a9a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-2d27-7656-8b22-5828f64b914d.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, white appliances including a refrigerator, stove, and double sink.",
        "public_id": "019d1c09-2d27-7656-8b22-5828f64b914d",
        "storage_key": "property/6767906449166906/019d1c09-2d27-7656-8b22-5828f64b914d.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinets, a white stove, a double sink, and ample counter space. This kitchen is ready for you to prepare your favorite meals.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, white appliances including a refrigerator, stove, and double sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantUpgradedKitchen.jpg"
    },
    {
      "id": "ec_09d85c8d35965e91542ce95a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-9f29-7532-82b7-fe43ce70695c.webp",
      "image_media": {
        "alt_text": "Kitchen with double sink, refrigerator, and stove.",
        "public_id": "019d1c09-9f29-7532-82b7-fe43ce70695c",
        "storage_key": "property/6767906449166906/019d1c09-9f29-7532-82b7-fe43ce70695c.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinets, a double sink with a modern faucet, a white refrigerator, and a white electric stove. Ample counter space and a pantry are visible.",
      "link": "false",
      "alt_text": "Kitchen with double sink, refrigerator, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantUpgradedKitchenBar.jpg"
    },
    {
      "id": "ec_83a34e5fee2e7e43e450cda0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-9f93-77e9-b186-daf6721a9fe9.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, white refrigerator, and white stove.",
        "public_id": "019d1c09-9f93-77e9-b186-daf6721a9fe9",
        "storage_key": "property/6767906449166906/019d1c09-9f93-77e9-b186-daf6721a9fe9.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "A functional kitchen featuring dark wood cabinets, a white refrigerator, and a white electric stove, with a granite countertop breakfast bar.",
      "link": "false",
      "alt_text": "Kitchen with dark cabinets, white refrigerator, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantUpgradedKitchenDiningArea.jpg"
    },
    {
      "id": "ec_88d5cb5bec439cd173a9a80b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-a051-7678-972d-699bd6e6a6bb.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a breakfast bar and beige carpet.",
        "public_id": "019d1c09-a051-7678-972d-699bd6e6a6bb",
        "storage_key": "property/6767906449166906/019d1c09-a051-7678-972d-699bd6e6a6bb.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a breakfast bar, tiled flooring, and plush carpeting. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a breakfast bar and beige carpet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantDiningArea.jpg"
    },
    {
      "id": "ec_bd1deb15faa8742e19fcd035",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-a6fb-74ff-b6a8-9447d6176827.webp",
      "image_media": {
        "alt_text": "Interior view of a living room with a fireplace and sliding glass door.",
        "public_id": "019d1c09-a6fb-74ff-b6a8-9447d6176827",
        "storage_key": "property/6767906449166906/019d1c09-a6fb-74ff-b6a8-9447d6176827.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and a sliding glass door leading to an outdoor space. Perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Interior view of a living room with a fireplace and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantDiningAreaEntry.jpg"
    },
    {
      "id": "ec_6c17ababc0027e2c3aaebd24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-afee-76e9-b28c-8d8ecac9723c.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a sliding glass door with vertical blinds.",
        "public_id": "019d1c09-afee-76e9-b28c-8d8ecac9723c",
        "storage_key": "property/6767906449166906/019d1c09-afee-76e9-b28c-8d8ecac9723c.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with a granite surround and a sliding glass door leading to the outdoors. Neutral carpeting throughout.",
      "link": "false",
      "alt_text": "Living room with a fireplace and a sliding glass door with vertical blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_0f2bba1083f1e1c1391db106",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-acd7-77a0-975f-b2b21ffdf86a.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub.",
        "public_id": "019d1c09-acd7-77a0-975f-b2b21ffdf86a",
        "storage_key": "property/6767906449166906/019d1c09-acd7-77a0-975f-b2b21ffdf86a.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a bathtub with shower.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_VacantUpgradedBathroom.jpg"
    },
    {
      "id": "ec_e2901da1b0c1b05bae48a30d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-e916-779c-ac78-aa2add017d62.webp",
      "image_media": {
        "alt_text": "Sierra Glen Apartments monument sign with address 7321.",
        "public_id": "01a08a0a-e916-779c-ac78-aa2add017d62",
        "storage_key": "property/6767906449166906/01a08a0a-e916-779c-ac78-aa2add017d62.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to Sierra Glen Apartments! This monument sign with the property's address, 7321, is surrounded by trees and landscaping.",
      "link": "false",
      "alt_text": "Sierra Glen Apartments monument sign with address 7321.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_EntrySignLandscaping.jpg"
    },
    {
      "id": "ec_af784a3d0dff2d17ae2dd09e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-0539-76c7-a6d1-69419a5d5299.webp",
      "image_media": {
        "alt_text": "Pathway to leasing office with Sierra Glen Apartments sign",
        "public_id": "01a08a0b-0539-76c7-a6d1-69419a5d5299",
        "storage_key": "property/6767906449166906/01a08a0b-0539-76c7-a6d1-69419a5d5299.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Welcome to Sierra Glen Apartments, where you'll find your home. Visit our leasing office to learn more about our community.",
      "link": "false",
      "alt_text": "Pathway to leasing office with Sierra Glen Apartments sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_LeasingOffice.jpg"
    },
    {
      "id": "ec_5e365a325885561b4be39574",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-4a92-7779-b03e-4863148bd430.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "01a08a0b-4a92-7779-b03e-4863148bd430",
        "storage_key": "property/6767906449166906/01a08a0b-4a92-7779-b03e-4863148bd430.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. A perfect spot to cool off and enjoy the California sunshine.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PoolBuildings.jpg"
    },
    {
      "id": "ec_7665132aad812b080478875e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-147a-741a-ae2a-11a62a67e637.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and tables.",
        "public_id": "01a08a0b-147a-741a-ae2a-11a62a67e637",
        "storage_key": "property/6767906449166906/01a08a0b-147a-741a-ae2a-11a62a67e637.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. The perfect spot to relax and unwind.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PoolLounges.jpg"
    },
    {
      "id": "ec_da201a1b4d4da5ff9e174860",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-4880-75db-bc49-62fccf410f22.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
        "public_id": "01a08a0a-4880-75db-bc49-62fccf410f22",
        "storage_key": "property/6767906449166906/01a08a0a-4880-75db-bc49-62fccf410f22.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the sparkling outdoor swimming pool and relaxing hot tub, perfect for sunny days and unwinding after a long week. Surrounded by comfortable lounge chairs and tables.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PoolSpa(1).jpg"
    },
    {
      "id": "ec_a73d148896caa7e760cb5a61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-f603-74bd-b0e7-e33f574de421.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a hot tub.",
        "public_id": "01a08a0a-f603-74bd-b0e7-e33f574de421",
        "storage_key": "property/6767906449166906/01a08a0a-f603-74bd-b0e7-e33f574de421.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing and unwinding. Surrounded by comfortable lounge chairs and a soothing hot tub, this amenity offers a great space to soak up the sun and enjoy the beautiful weather.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a hot tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_SwimmingPoolLeasingOffice.jpg"
    },
    {
      "id": "ec_65f280ef324f97c8598479f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-5113-765d-a6f8-718f150f3df5.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool and hot tub with lounge chairs and tables.",
        "public_id": "01a08a0a-5113-765d-a6f8-718f150f3df5",
        "storage_key": "property/6767906449166906/01a08a0a-5113-765d-a6f8-718f150f3df5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or relax in the soothing hot tub. Ample lounge chairs and seating areas are available for your convenience.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool and hot tub with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PoolSpaCoveredArea.jpg"
    },
    {
      "id": "ec_6939dfb5b6d64171883e3333",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-60f5-774c-a3fa-0da935259c43.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables, surrounded by apartment buildings.",
        "public_id": "01a08a0b-60f5-774c-a3fa-0da935259c43",
        "storage_key": "property/6767906449166906/01a08a0b-60f5-774c-a3fa-0da935259c43.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the soothing hot tub. Perfect for unwinding and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and tables, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PoolExterior.jpg"
    },
    {
      "id": "ec_3081047a4dfb6332cfe7e3ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-8a67-77fa-8104-371bcb5a0908.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, chimneys, and landscaping.",
        "public_id": "01a08a0b-8a67-77fa-8104-371bcb5a0908",
        "storage_key": "property/6767906449166906/01a08a0b-8a67-77fa-8104-371bcb5a0908.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing balconies, chimneys, and well-maintained landscaping. A pathway leads alongside the buildings and green lawns.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies, chimneys, and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_BuildingExteriors.jpg"
    },
    {
      "id": "ec_3d50a3524dca15785d1b3bcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-7ac4-707f-a710-16a8d9a52145.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, walkways, and landscaping.",
        "public_id": "01a08a0b-7ac4-707f-a710-16a8d9a52145",
        "storage_key": "property/6767906449166906/01a08a0b-7ac4-707f-a710-16a8d9a52145.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Charming apartment buildings surrounded by lush green lawns, manicured hedges, and winding pathways. Enjoy the exterior beauty of our community.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies, walkways, and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_ExteriorEntries.jpg"
    },
    {
      "id": "ec_4ed62ad09207681088cee9c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-b74c-719f-9173-3b60a9d01dc9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and green lawn.",
        "public_id": "01a08a0b-b74c-719f-9173-3b60a9d01dc9",
        "storage_key": "property/6767906449166906/01a08a0b-b74c-719f-9173-3b60a9d01dc9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing balconies, manicured lawns, and lush landscaping, creating a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with balconies and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_CommunityPaths.jpg"
    },
    {
      "id": "ec_8a156e72dc14cf765d96fcfd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-e5c6-72cd-911f-8342f7e6b952.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a paved walkway and green lawn.",
        "public_id": "01a08a0b-e5c6-72cd-911f-8342f7e6b952",
        "storage_key": "property/6767906449166906/01a08a0b-e5c6-72cd-911f-8342f7e6b952.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with a scenic walkway and lush green grass, creating a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Apartment building exterior with a paved walkway and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_GreenSpace.jpg"
    },
    {
      "id": "ec_5dbde9c617cf89cde124da0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-a0d0-7168-9e57-c330a8edde70.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and outdoor grills.",
        "public_id": "01a08a0b-a0d0-7168-9e57-c330a8edde70",
        "storage_key": "property/6767906449166906/01a08a0b-a0d0-7168-9e57-c330a8edde70.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "A view of the exterior of apartment buildings, showcasing their balconies and available outdoor grilling spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and outdoor grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_PatiosDecks.jpg"
    },
    {
      "id": "ec_cc5c959768a26c75e2948100",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d1c09-2d7e-76e1-b2d2-31c24a57794f.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019d1c09-2d7e-76e1-b2d2-31c24a57794f",
        "storage_key": "property/6767906449166906/019d1c09-2d7e-76e1-b2d2-31c24a57794f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with a washing machine and dryer for every resident.",
      "link": "false",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_LaundryCareCenter.jpg"
    },
    {
      "id": "ec_21a4f31f7447cd2cfea0c97a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0a-30ac-722c-a2ed-46156ef1ccd3.webp",
      "image_media": {
        "alt_text": "Amazon package locker system outside apartment building.",
        "public_id": "01a08a0a-30ac-722c-a2ed-46156ef1ccd3",
        "storage_key": "property/6767906449166906/01a08a0a-30ac-722c-a2ed-46156ef1ccd3.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Secure and convenient Amazon package lockers are available for residents, offering a safe place for deliveries.",
      "link": "false",
      "alt_text": "Amazon package locker system outside apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_24HourPackageLockers.jpg"
    },
    {
      "id": "ec_d592bd824038d514825ee68c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/01a08a0b-6fca-706e-b7a9-93a20854ce64.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with mailboxes and stairs.",
        "public_id": "01a08a0b-6fca-706e-b7a9-93a20854ce64",
        "storage_key": "property/6767906449166906/01a08a0b-6fca-706e-b7a9-93a20854ce64.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "This image shows the exterior of an apartment complex, featuring rows of mailboxes, well-maintained landscaping, and outdoor staircases leading to upper-level units.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with mailboxes and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SierraGlen_CitrusHeights_CA_Mailboxes.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fbec582e-9435-4c1f-a4a1-81e1e0dd8b3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-d8c0-7168-8038-b16703d6fd24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-d8c0-7168-8038-b16703d6fd24",
        "storage_key": "property/6767906449166906/019d08af-d8c0-7168-8038-b16703d6fd24.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7e11-7238-8d3d-d4a094c240ea",
        "storage_key": "property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_33aafe89-b849-4da1-80d7-68410e720d4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Hibachi Buffet, Sushi & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5623 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Budget eatery featuring a large variety of Japanese and Asian dishes, including sushi and pizza, as well as a hibachi grill.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh seafood, sushi, and grilled dishes, including frog legs and garlic crabs. They also highlight the reasonable prices, the fun hibachi grill, and the friendly, attentive staff who quickly clear plates and refill drinks.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-da13-725f-9bf4-83f014bb8ceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-da13-725f-9bf4-83f014bb8ceb",
        "storage_key": "property/6767906449166906/019d08af-da13-725f-9bf4-83f014bb8ceb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://hibachibuffetsacramento.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10003753580362333522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hibachi-buffet-sushi--grill",
      "poi_latitude": "38.6682741",
      "poi_longitude": "-121.2729759",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-961-1508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7e11-7238-8d3d-d4a094c240ea",
        "storage_key": "property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09bAx4TfmoARUv0JEuF41Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_8fbadbfc-ae93-4a57-87e4-0dd354127b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-dacc-75e9-9ad3-8ee169116db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-dacc-75e9-9ad3-8ee169116db3",
        "storage_key": "property/6767906449166906/019d08af-dacc-75e9-9ad3-8ee169116db3.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7e11-7238-8d3d-d4a094c240ea",
        "storage_key": "property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_cee0ebe7-1e72-485c-bed7-f8f2057cfe12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-e0a8-73ed-9e89-f6654ef4d0a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e0a8-73ed-9e89-f6654ef4d0a4",
        "storage_key": "property/6767906449166906/019d08af-e0a8-73ed-9e89-f6654ef4d0a4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7e11-7238-8d3d-d4a094c240ea",
        "storage_key": "property/6767906449166906/019d08af-7e11-7238-8d3d-d4a094c240ea.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_da2be088-6b8d-4fc5-ae23-8459013ad85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-dedb-75bf-a19b-9cfae415db5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-dedb-75bf-a19b-9cfae415db5d",
        "storage_key": "property/6767906449166906/019d08af-dedb-75bf-a19b-9cfae415db5d.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-820f-70ad-a73e-88a03a89ab01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-820f-70ad-a73e-88a03a89ab01",
        "storage_key": "property/6767906449166906/019d08af-820f-70ad-a73e-88a03a89ab01.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f91ba670-3967-4c64-9ef8-0a4209c2c694",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-e2dc-7388-a84a-8d200e3ca968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e2dc-7388-a84a-8d200e3ca968",
        "storage_key": "property/6767906449166906/019d08af-e2dc-7388-a84a-8d200e3ca968.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-81ea-76e8-88dd-63ea18aadaad",
        "storage_key": "property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9df6268d-b3ed-4752-a3fe-3624431fa5f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-e3f6-76f8-9cd7-247cbcf4f21b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e3f6-76f8-9cd7-247cbcf4f21b",
        "storage_key": "property/6767906449166906/019d08af-e3f6-76f8-9cd7-247cbcf4f21b.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-81ea-76e8-88dd-63ea18aadaad",
        "storage_key": "property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_2993d41f-2713-4fc4-b939-4c3e1ffd3709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-e872-775a-95a5-051309e5ba53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e872-775a-95a5-051309e5ba53",
        "storage_key": "property/6767906449166906/019d08af-e872-775a-95a5-051309e5ba53.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-81ea-76e8-88dd-63ea18aadaad",
        "storage_key": "property/6767906449166906/019d08af-81ea-76e8-88dd-63ea18aadaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2e359d9b-2252-4b5d-8502-1efb31123daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 Madison Ave, Carmichael, CA 95608, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store is well-stocked with a wide variety of products, and the staff are friendly, helpful, and knowledgeable. They also highlight the convenient location and efficient checkout process.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-e8fd-702e-b6be-7be8d04ef5c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e8fd-702e-b6be-7be8d04ef5c1",
        "storage_key": "property/6767906449166906/019d08af-e8fd-702e-b6be-7be8d04ef5c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Carmichael/CA/Carmichael/95608/650?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10135906078489022522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.6627218",
      "poi_longitude": "-121.3260026",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-344-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-820f-70ad-a73e-88a03a89ab01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-820f-70ad-a73e-88a03a89ab01",
        "storage_key": "property/6767906449166906/019d08af-820f-70ad-a73e-88a03a89ab01.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgUYk1O7emoAROpAPReD4qYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a5899ef4-5c5c-4d00-8e92-21cd50f0c515",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "American River College",
      "poi_type": "Education",
      "poi_address": "4700 College Oak Dr, Sacramento, CA 95841, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-eab7-73cf-8c34-621b9f8acb99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-eab7-73cf-8c34-621b9f8acb99",
        "storage_key": "property/6767906449166906/019d08af-eab7-73cf-8c34-621b9f8acb99.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "https://arc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1010375658575580987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "american-river-college",
      "poi_latitude": "38.6511479",
      "poi_longitude": "-121.3467327",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-484-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-8245-717a-b532-a63b43278008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8245-717a-b532-a63b43278008",
        "storage_key": "property/6767906449166906/019d08af-8245-717a-b532-a63b43278008.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS44sh8nemoARO08Z606TBQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f0a78cc0-a2aa-4138-8ce2-69014184a8b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-ed18-710d-aefc-2f72bacc306e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-ed18-710d-aefc-2f72bacc306e",
        "storage_key": "property/6767906449166906/019d08af-ed18-710d-aefc-2f72bacc306e.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3646b697-a856-49c5-a20b-0bcb8765ba9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Aerospace Museum of California",
      "poi_type": "Entertainment",
      "poi_address": "3200 Freedom Park Dr, McClellan Park, CA 95652, USA",
      "poi_short_description": "Exhibits of planes from various periods plus spacecraft, cockpit visits & high-tech simulators.",
      "poi_long_description": "People say this science museum offers a variety of aircraft, engines, and flight simulators, and provides fun, interactive activities like a scavenger hunt. They highlight the reasonable admission prices, the engaging and educational experience, and the kid-friendly atmosphere. They also like the knowledgeable and friendly staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-efd9-703c-a52c-09ae754d50b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-efd9-703c-a52c-09ae754d50b5",
        "storage_key": "property/6767906449166906/019d08af-efd9-703c-a52c-09ae754d50b5.webp",
        "width": 1280,
        "height": 671
      },
      "poi_business_url": "https://aerospaceca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14856061747299288910&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aerospace-museum-of-california",
      "poi_latitude": "38.6750306",
      "poi_longitude": "-121.3909217",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-643-3192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-8721-709f-8d2e-07e06e9a20aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8721-709f-8d2e-07e06e9a20aa",
        "storage_key": "property/6767906449166906/019d08af-8721-709f-8d2e-07e06e9a20aa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_KJqo3YmoARTgcLyXJVK84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b936c8dd-000f-4059-9880-1e2280df1b95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-efcd-76ee-8646-ef61b8a9da6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-efcd-76ee-8646-ef61b8a9da6f",
        "storage_key": "property/6767906449166906/019d08af-efcd-76ee-8646-ef61b8a9da6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_da8e5b56-7b82-45fe-b8ff-dd71217b92ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-f029-710a-9896-52fe601ec37c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f029-710a-9896-52fe601ec37c",
        "storage_key": "property/6767906449166906/019d08af-f029-710a-9896-52fe601ec37c.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-8721-709f-8d2e-07e06e9a20aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8721-709f-8d2e-07e06e9a20aa",
        "storage_key": "property/6767906449166906/019d08af-8721-709f-8d2e-07e06e9a20aa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a0283b20-7d92-4d72-92f0-7f0f777e686a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "ARC Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4700 College Oak Dr, Sacramento, CA 95841, USA",
      "poi_short_description": "Stadium with a track and field, hosting baseball games and other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-f30e-706e-9409-56b4a12127a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f30e-706e-9409-56b4a12127a1",
        "storage_key": "property/6767906449166906/019d08af-f30e-706e-9409-56b4a12127a1.webp",
        "width": 1280,
        "height": 752
      },
      "poi_business_url": "http://arc.losrios.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904538000052726170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arc-stadium",
      "poi_latitude": "38.6466506",
      "poi_longitude": "-121.3478243",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-484-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-1aa6-706a-b879-038601d9cc67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b0-1aa6-706a-b879-038601d9cc67",
        "storage_key": "property/6767906449166906/019d08b0-1aa6-706a-b879-038601d9cc67.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJezZADrbemoARmikc_iFGk3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_41fcfd43-eef2-453d-86d7-6a810e364c37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-f504-7499-9129-2c49dd2a7771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f504-7499-9129-2c49dd2a7771",
        "storage_key": "property/6767906449166906/019d08af-f504-7499-9129-2c49dd2a7771.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2fe534ba-bdc6-48d4-8dc8-68365adb5298",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5995 Birdcage Centre Ln, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Family-friendly fitness center with a pool and a turf area, plus a recovery room.",
      "poi_long_description": "People say this fitness center offers a wide variety of workout equipment, classes, and amenities, including a pool, steam room, and kids club. They also highlight the friendly staff, clean facilities, and affordable membership options.\n\nOther reviews mention the gym can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-fb2d-71eb-9269-18d0d3ef7a5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fb2d-71eb-9269-18d0d3ef7a5e",
        "storage_key": "property/6767906449166906/019d08af-fb2d-71eb-9269-18d0d3ef7a5e.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/birdcage/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14653391668038982145&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "38.6738583",
      "poi_longitude": "-121.2754293",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-745-8725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2ivl0PfmoARAdohyBVOW8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3acf4491-6379-4785-ad3d-befb1c3219b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-fc54-776a-b569-598ded0214a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fc54-776a-b569-598ded0214a4",
        "storage_key": "property/6767906449166906/019d08af-fc54-776a-b569-598ded0214a4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ba1290a7-08f6-4219-92a8-83d0cdc31160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6633 Auburn Blvd, Citrus Heights, CA 95621, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of fitness classes, including Zumba, and has new workout equipment. They also highlight the friendly and helpful staff, and the clean and welcoming environment.\n\nOther reviews mention the sauna can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-4251-7038-beec-b56b24bfc264.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4251-7038-beec-b56b24bfc264",
        "storage_key": "property/6767906449166906/019d08af-4251-7038-beec-b56b24bfc264.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/citrus-heights-ca/citrus-heights-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17849616961644275333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.68723",
      "poi_longitude": "-121.31003",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-722-7588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-OX4AffmoARhSaYJw6Utvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b54f345c-3279-4e03-9869-a9e2597c292a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-feab-77af-a715-c0f0e041f96e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-feab-77af-a715-c0f0e041f96e",
        "storage_key": "property/6767906449166906/019d08af-feab-77af-a715-c0f0e041f96e.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9eb633f5-044a-4810-a67c-f587ce099ba0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1159 Roseville Square Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Clean, friendly, well-equipped facility that's part of a chain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-4272-738f-8442-236fbbe7498a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4272-738f-8442-236fbbe7498a",
        "storage_key": "property/6767906449166906/019d08af-4272-738f-8442-236fbbe7498a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/roseville-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11658269411521409879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7468683",
      "poi_longitude": "-121.2740643",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-604-8235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0EtYWchm4ARVzOJ-UJ-yqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_74c2097c-e34c-4c9e-ad0b-36f2fc7ed800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-6eff-77eb-87b2-536506032e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-6eff-77eb-87b2-536506032e65",
        "storage_key": "property/6767906449166906/019d08af-6eff-77eb-87b2-536506032e65.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-871c-746d-b929-b282ca0a314f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-871c-746d-b929-b282ca0a314f",
        "storage_key": "property/6767906449166906/019d08af-871c-746d-b929-b282ca0a314f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2e6e7bc4-26a2-4739-bd1f-a59529f99d20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Mercy San Juan Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 Coyle Ave, Carmichael, CA 95608, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-3969-75db-b735-1e9bd195d8ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-3969-75db-b735-1e9bd195d8ed",
        "storage_key": "property/6767906449166906/019d08af-3969-75db-b735-1e9bd195d8ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dignityhealth.org/mercy-san-juan-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=323581014851310780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-san-juan-medical-center",
      "poi_latitude": "38.6696173",
      "poi_longitude": "-121.3140834",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-537-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-871c-746d-b929-b282ca0a314f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-871c-746d-b929-b282ca0a314f",
        "storage_key": "property/6767906449166906/019d08af-871c-746d-b929-b282ca0a314f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbHHnfnemoARvNRF9jeXfQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bced5272-09d2-4a85-9e04-3e4e36949fb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-043f-733d-b01b-6a599f590ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-043f-733d-b01b-6a599f590ae3",
        "storage_key": "property/6767906449166906/019d08b0-043f-733d-b01b-6a599f590ae3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f8-7238-89c6-38bdbfb78bb0",
        "storage_key": "property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51386fc7-1f98-4f94-a194-cad61e87eb0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Rusch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7801 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Outdoor skating & biking spot with concrete surface, numerous unique features & lighting at night.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including pickleball courts, tennis courts, a swimming pool, playgrounds, and walking trails. They also highlight the clean and well-maintained grounds, and the spacious open areas perfect for picnics and recreational activities.\n\nOther reviews mention there can be homeless people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-04bb-7651-a4b6-9e14242e5580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-04bb-7651-a4b6-9e14242e5580",
        "storage_key": "property/6767906449166906/019d08b0-04bb-7651-a4b6-9e14242e5580.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sunriseparks.com/rusch-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352438582190195855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rusch-community-park",
      "poi_latitude": "38.70897069999999",
      "poi_longitude": "-121.2912232",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f8-7238-89c6-38bdbfb78bb0",
        "storage_key": "property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCebD9pDfmoARj8SW8AUd5AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96ba6da1-68ec-400d-a503-47e2951092d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-043f-733d-b01b-6ceb145f50a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-043f-733d-b01b-6ceb145f50a0",
        "storage_key": "property/6767906449166906/019d08b0-043f-733d-b01b-6ceb145f50a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f8-7238-89c6-38bdbfb78bb0",
        "storage_key": "property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c36d1ad1-79ca-4701-9520-79de0fce918d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-067f-75cb-99e2-662f2b55a105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-067f-75cb-99e2-662f2b55a105",
        "storage_key": "property/6767906449166906/019d08b0-067f-75cb-99e2-662f2b55a105.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f8-7238-89c6-38bdbfb78bb0",
        "storage_key": "property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9d935b39-c194-4b00-a142-75fe58cd3b7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Gibson Ranch Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8556 Gibson Ranch Park Rd, Elverta, CA 95626, USA",
      "poi_short_description": "Large park with nature trails, farm animals, horseback riding, camping, outdoor concerts & events.",
      "poi_long_description": "People say this park offers fishing, picnic areas, and walking trails. They highlight the spacious green grass, beautiful views, and family-friendly atmosphere. They also like the ample parking, well-maintained facilities, and availability of barbecue pits and seating for large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-0bd1-762c-9ea9-d6fa0b605fa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0bd1-762c-9ea9-d6fa0b605fa4",
        "storage_key": "property/6767906449166906/019d08b0-0bd1-762c-9ea9-d6fa0b605fa4.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://regionalparks.saccounty.net/Parks/RegionalParksDetails/Pages/GibsonRanch.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6179385611734743009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gibson-ranch-regional-park",
      "poi_latitude": "38.723755",
      "poi_longitude": "-121.4034049",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f8-7238-89c6-38bdbfb78bb0",
        "storage_key": "property/6767906449166906/019d08af-86f8-7238-89c6-38bdbfb78bb0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUOh66snm4AR4febXXmWwVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ae04d23c-e7ca-41ec-af62-1c5a72ba9af4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-1004-772a-a996-a831ac0b194d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1004-772a-a996-a831ac0b194d",
        "storage_key": "property/6767906449166906/019d08b0-1004-772a-a996-a831ac0b194d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dbfad87d-4d65-4769-9132-1f92d6cf0a27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-0fcf-74b9-99d1-96c85c2ce316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0fcf-74b9-99d1-96c85c2ce316",
        "storage_key": "property/6767906449166906/019d08b0-0fcf-74b9-99d1-96c85c2ce316.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b90b4059-2f88-44bb-8334-7ca0151cc879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_545d33d1-5b66-47a9-a017-2e80865b9abd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "Norcanna Farms Cannabis Delivery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08b0-1047-7577-bdd9-5b52a9049f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1047-7577-bdd9-5b52a9049f1a",
        "storage_key": "property/6767906449166906/019d08b0-1047-7577-bdd9-5b52a9049f1a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://norcannafarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13645295156685364849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norcanna-farms-cannabis-delivery",
      "poi_latitude": "38.69166260000001",
      "poi_longitude": "-121.2721073",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-671-3446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxpQROffmoARcd6WLabTXb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ed52ed80-9f36-4e8f-8622-e2cece1b2409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-7d7e-7138-966d-49b67ad35f53",
        "storage_key": "property/6767906449166906/019d08af-7d7e-7138-966d-49b67ad35f53.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5acb959c1f37ee4c7c176808",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_fffda1b2a16518438425ba3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_f8d0da08a8d32462cd86b16e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_38e04438a18f92d144fa4767",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_472b6411efd57f810b5f6a3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_53f33bdbbeb57fe40a3a34c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_281d23c6-5b23-4675-be6d-eae6d9fa73b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "rating": "5.0",
      "name": "Marie Walker",
      "text": "I must say thanks to the entire staff for their prompt response to the issue i was having",
      "date": "2025-10-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f9718408-0a33-4e56-a0de-fc3ed926a673",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-44c9-71bf-a2d4-1041c384cbd8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-44c9-71bf-a2d4-1041c384cbd8",
        "storage_key": "property/6767906449166906/019d314e-44c9-71bf-a2d4-1041c384cbd8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - Studio 420 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1FZgnXi3aPg"
    },
    {
      "id": "custom_d89e5ea1-d596-4114-98f2-cc4d3032ac27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-5be7-70ff-a78d-bc4ce7c4147c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-5be7-70ff-a78d-bc4ce7c4147c",
        "storage_key": "property/6767906449166906/019d314e-5be7-70ff-a78d-bc4ce7c4147c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - 1 Bedroom 1 Bath 634 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iSxeEcX2nbX"
    },
    {
      "id": "custom_bbd40542-db5d-4239-b7ee-97513a784734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-6ec3-755c-8a74-3390805bf574.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-6ec3-755c-8a74-3390805bf574",
        "storage_key": "property/6767906449166906/019d314e-6ec3-755c-8a74-3390805bf574.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - 2 Bedroom 1 Bath 834 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hmXue5MBjp3"
    },
    {
      "id": "custom_e15c1d90-c45f-4b6d-a00a-b0e7174dcebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-81f1-73f5-a37e-dc3cbe4ef14b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-81f1-73f5-a37e-dc3cbe4ef14b",
        "storage_key": "property/6767906449166906/019d314e-81f1-73f5-a37e-dc3cbe4ef14b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - 2 Bedroom 2 Bath 932 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fKgHPCSWMmh"
    },
    {
      "id": "custom_105c0893-b279-477a-882a-c4be0bb0f251",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-93f0-72ba-a25c-334f0f85763a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-93f0-72ba-a25c-334f0f85763a",
        "storage_key": "property/6767906449166906/019d314e-93f0-72ba-a25c-334f0f85763a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sN5GD7fr4Qc"
    },
    {
      "id": "custom_f833f227-a6a5-4364-aae4-01ec9fbd6378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166906/019d314e-a505-7178-9d16-ba03a7c395aa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d314e-a505-7178-9d16-ba03a7c395aa",
        "storage_key": "property/6767906449166906/019d314e-a505-7178-9d16-ba03a7c395aa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sierra Glen Apartments - Laundry Facility",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NVxA5xwRUx9"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c2-0988-7229-b0bd-1fcfbea45ea6",
      "lead_source": "LANDING_PAGE",
      "name": "Sierra Glen Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-with-pool-citrus-heights-ca",
      "search_query": "apartments with pool in Citrus Heights CA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Citrus Heights, CA",
      "h2_subtitle": "Discover Sierra Glen's inviting pool in Citrus Heights. Dive into relaxation at our premium apartment community.",
      "page_copy": "Sierra Glen offers ideal living in Citrus Heights, CA, with a standout feature: our sparkling pool. Perfectly designed for relaxation and recreation, the pool area provides a serene escape where you can unwind under the California sun. Nestled within lively Citrus Heights, our community combines comfort and convenience.\n\nIn addition to the refreshing pool, Sierra Glen caters to modern living with amenities such as high-speed internet access, efficient heating, and a smoke-free environment. Our apartments, equipped with cozy fireplaces, ensure a warm, inviting atmosphere. Experience the perfect blend of leisure and lifestyle at Sierra Glen, where our pool is just one element of a vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sierra Glen Apartments with Pool in Citrus Heights, CA",
      "seo_description": "Discover Sierra Glen in Citrus Heights, CA. Enjoy our apartments with a pool and amenities like high-speed internet and fireplaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-sacramento-county",
      "search_query": "smoke free apartments Sacramento County",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Sacramento County",
      "h2_subtitle": "Enjoy smoke-free living at Sierra Glen, located in Sacramento County. Experience a fresh, clean environment in our well-appointed apartments.",
      "page_copy": "At Sierra Glen in Citrus Heights, CA, we are proud to offer smoke-free apartments that promote a healthy and pleasant living environment in the heart of Sacramento County. Our commitment to providing a smoke-free community ensures that residents can enjoy clean air and a peaceful atmosphere every day in our picturesque setting.\n\nIn addition to our smoke-free policy, residents have access to a range of amenities including high-speed internet access, cozy fireplaces, and efficient heating systems. You can also relax by the pool or take advantage of the many attractions nearby in vibrant Citrus Heights. Discover the benefits of living in a smoke-free, amenity-rich community at Sierra Glen.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Sacramento County",
      "seo_description": "Experience smoke-free living at Sierra Glen, Sacramento County. Enjoy clean air and great amenities like a pool, fireplaces, and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "walk-in-closets-apartments-near-95621",
      "search_query": "walk-in closets apartments near 95621",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets Near 95621",
      "h2_subtitle": "Discover Sierra Glen's spacious apartments near 95621, featuring walk-in closets. Enjoy ample storage and modern living.",
      "page_copy": "Sierra Glen offers spacious apartment homes near the 95621 area that include the luxury of walk-in closets. Our thoughtfully designed units provide the perfect solution for those seeking additional storage without compromising on style and convenience. Enjoy the comfort of having ample space to store your wardrobe and personal items.\n\nLocated in Citrus Heights, just a short distance from the heart of Sacramento County, Sierra Glen combines modern amenities with a desirable location. Residents benefit from high-speed internet access, comfortable heating, and the tranquility of a smoke-free community. Dive into our inviting pool or cozy up by the fireplace, all while enjoying the added luxury of walk-in closets. Discover premium living at Sierra Glen today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets Near 95621",
      "seo_description": "Explore Sierra Glen's apartments near 95621 with walk-in closets. Enjoy spacious storage, a pool, and modern amenities in Citrus Heights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "fireplace-apartments-citrus-heights",
      "search_query": "fireplace apartments Citrus Heights",
      "category": "Amenity",
      "h1_title": "Fireplace Apartments in Citrus Heights",
      "h2_subtitle": "Cozy up in Sierra Glen's fireplace apartments, right in Citrus Heights. Enjoy warmth and charm in our lovely community.",
      "page_copy": "At Sierra Glen in Citrus Heights, our fireplace apartments provide the perfect cozy retreat. Ideal for relaxing after a long day, our fireplaces bring warmth and charm to your home, creating a welcoming atmosphere all year round. Whether you are hosting friends or enjoying a quiet night in, our fireplace apartments offer the perfect setting.\n\nOur community is located in the vibrant city of Citrus Heights and offers various amenities, including high-speed internet access, heating, and a smoke-free environment. Spend your leisure time at our refreshing pool or explore the nearby local attractions that Citrus Heights has to offer. Discover the balance of comfort and modern living at Sierra Glen's fireplace apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fireplace Apartments in Citrus Heights",
      "seo_description": "Discover Sierra Glen's fireplace apartments in Citrus Heights. Enjoy modern amenities, warmth, and style in a smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "high-speed-internet-apartments-citrus-heights",
      "search_query": "high speed internet apartments Citrus Heights",
      "category": "Amenity",
      "h1_title": "High Speed Internet Apartments in Citrus Heights",
      "h2_subtitle": "Stay connected with Sierra Glen's high-speed internet apartments in Citrus Heights. Enjoy efficient, modern living with us.",
      "page_copy": "At Sierra Glen in Citrus Heights, we understand the importance of staying connected. Our high-speed internet apartments offer you seamless online access, ensuring that you can work, stream, and browse with ease. Our community is perfect for tech-savvy individuals who appreciate the convenience of fast and reliable internet service right at home.\n\nLocated in the lively city of Citrus Heights, Sierra Glen offers more than just connectivity. Residents can enjoy amenities such as a welcoming fireplace, heating for year-round comfort, and a smoke-free environment. Our sparkling pool provides a refreshing retreat, complementing the modern living experience. Discover a community that meets all your digital and lifestyle needs at Sierra Glen in Citrus Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Speed Internet Apartments in Citrus Heights",
      "seo_description": "Enjoy Sierra Glen's high-speed internet apartments in Citrus Heights. Experience modern living with seamless connectivity and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "studio-apartment-citrus-heights",
      "search_query": "studio apartment citrus heights",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Citrus Heights",
      "h2_subtitle": "Discover Sierra Glen's stylish studio apartments in Citrus Heights. Compact living with premium amenities awaits you here.",
      "page_copy": "Experience the perfect blend of comfort and style with our studio apartments at Sierra Glen in Citrus Heights. These thoughtfully designed spaces maximize every square foot, offering a modern living solution tailored to your lifestyle. Whether you're a student, professional, or anyone seeking a low-maintenance, streamlined home, our studio apartments are ideal.\n\nSituated in Citrus Heights, Sierra Glen combines the allure of city living with suburban tranquility. Our community provides residents with amenities such as high-speed internet access, heating, and a smoke-free environment. Enjoy leisure time by the pool or cozy evenings by the fireplace. Sierra Glen’s studio apartments offer the perfect haven for those who appreciate functionality paired with modern conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Citrus Heights",
      "seo_description": "Explore Sierra Glen's studio apartments in Citrus Heights. Enjoy compact, modern living with great amenities like a pool and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-sacramento-county",
      "search_query": "one bedroom apartments sacramento county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Explore Sierra Glen's one bedroom apartments in Sacramento County. Experience spacious living with modern comforts and amenities.",
      "page_copy": "Sierra Glen proudly offers inviting one bedroom apartments in Sacramento County, perfect for those looking to enjoy spacious living with contemporary features. Each apartment is thoughtfully designed to provide a comfortable and convenient lifestyle, making it an ideal choice for singles or couples who value both style and function.\n\nOur community is nestled in the heart of Citrus Heights, part of vibrant Sacramento County. Residents benefit from amenities like high-speed internet access, ensuring connectivity at all times, and cozy fireplaces to add warmth and ambiance. With facilities such as a smoke-free environment and a refreshing pool, Sierra Glen provides a serene haven while keeping you close to urban conveniences. Discover the perfect blend of community, comfort, and modern living in our one bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Sacramento County",
      "seo_description": "Discover one bedroom apartments at Sierra Glen in Sacramento County. Spacious living with modern amenities like high-speed internet and a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-95621",
      "search_query": "two bedroom apartments near 95621",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 95621",
      "h2_subtitle": "Find comfortable two bedroom apartments close to 95621 at Sierra Glen. Enjoy ample space and modern amenities in our vibrant community.",
      "page_copy": "Discover the perfect blend of space and comfort with our two bedroom apartments near the 95621 area, available at Sierra Glen. These thoughtfully designed units offer plenty of room for families or roommates seeking to enjoy a serene, yet connected lifestyle. Each apartment comes equipped with modern features to ensure you live with ease and style.\n\nLocated near the heart of Citrus Heights, Sierra Glen provides an array of amenities that enhance living quality. Enjoy high-speed internet access, which keeps you connected, and take advantage of our smoke-free environment for better health. The warmth of a cozy fireplace is perfect for relaxing evenings. Additionally, a sparkling pool beckons on warm days, making our two bedroom apartments an ideal choice for those desiring both convenience and community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 95621",
      "seo_description": "Explore Sierra Glen's spacious two bedroom apartments near 95621. Enjoy modern living with amenities like high-speed internet and a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-close-to-american-river-college",
      "search_query": "apartments close to American River College Citrus Heights",
      "category": "School",
      "h1_title": "Apartments Near American River College",
      "h2_subtitle": "Discover Sierra Glen's convenient location near American River College. Ideal for students seeking modern, comfortable living.",
      "page_copy": "Located just a short drive from American River College, Sierra Glen offers modern apartment living in Citrus Heights, making it an ideal home for students and faculty alike. Our community provides easy access to the college, allowing residents to balance their educational commitments with the comforts of home seamlessly.\n\nSierra Glen's apartments are thoughtfully designed to suit the needs of our residents, featuring amenities such as high-speed internet access, ensuring you stay connected for both study and leisure. Enjoy the peace of our smoke-free environment and take the opportunity to unwind by our refreshing pool after a busy day at college. With heating and fireplaces available, your comfort is our priority, no matter the season. Discover the convenience and charm of living close to American River College at Sierra Glen.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near American River College",
      "seo_description": "Find convenient apartments near American River College at Sierra Glen in Citrus Heights, featuring modern amenities like a pool and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-near-sutter-roseville-medical-center",
      "search_query": "apartments near Sutter Roseville Medical Center Citrus Heights",
      "category": "Hospital",
      "h1_title": "Apartments Near Sutter Roseville Medical Center",
      "h2_subtitle": "Live close to Sutter Roseville Medical Center in Citrus Heights. Sierra Glen offers modern apartments ideal for healthcare professionals.",
      "page_copy": "Ranked among the most convenient living choices, Sierra Glen provides modern, comfortable apartments near Sutter Roseville Medical Center in Citrus Heights. For medical professionals or patients seeking a nearby residence, our community offers easy access to the hospital, ensuring you are never far from work or care.\n\nOur apartments are equipped with amenities designed to cater to your lifestyle, including high-speed internet access for reliable connectivity, fireplaces to create a warm atmosphere, and a smoke-free environment ensuring healthy living conditions. With a beautiful pool available, you have the perfect spot to unwind and relax during your downtime. Discover a lifestyle of convenience and luxury at Sierra Glen, where proximity to Sutter Roseville Medical Center meets comfort and community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sutter Roseville Medical Center",
      "seo_description": "Discover modern apartments at Sierra Glen close to Sutter Roseville Medical Center in Citrus Heights, featuring amenities like a pool and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-near-mercy-san-juan-medical-center",
      "search_query": "apartments close to Mercy San Juan Medical Center Sacramento County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Mercy San Juan Medical",
      "h2_subtitle": "Experience the convenience of living near Mercy San Juan Medical Center. Sierra Glen offers ideal residences for healthcare professionals in Sacramento County.",
      "page_copy": "Sierra Glen proudly presents modern apartment living near Mercy San Juan Medical Center in the heart of Sacramento County. Perfect for healthcare workers or anyone needing frequent access to the medical center, our community provides an exceptional blend of convenience and comfort.\n\nOur thoughtfully designed apartments feature amenities such as high-speed internet access, keeping you connected professionally and personally. Enjoy a smoke-free environment that promotes better health, and relax in front of a cozy fireplace within your home. Our pool offers a refreshing retreat after a long day at the hospital, ensuring that relaxation is just a few steps away. At Sierra Glen, you’re not just close to Mercy San Juan; you’re close to everything that makes life easier and more enjoyable.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercy San Juan Medical Center",
      "seo_description": "Find comfortable, modern living at Sierra Glen, close to Mercy San Juan Medical Center in Sacramento County, with amenities like a pool and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-near-maidu-regional-park",
      "search_query": "apartments near Maidu Regional Park Citrus Heights",
      "category": "Park",
      "h1_title": "Apartments Near Maidu Regional Park",
      "h2_subtitle": "Live near Maidu Regional Park at Sierra Glen in Citrus Heights. Enjoy the perfect blend of nature and comfortable apartment living.",
      "page_copy": "Sierra Glen offers the perfect home for nature enthusiasts with its convenient location near Maidu Regional Park in Citrus Heights. This prime setting is ideal for those who appreciate a blend of outdoor activities and modern apartment amenities.\n\nRich in features, our apartments are designed with comfort in mind, providing high-speed internet access, smoke-free living, and cozy fireplaces. Whether you're spending a day exploring the park's trails or relaxing by our community pool, Sierra Glen ensures a balanced lifestyle. Be a part of a vibrant community while being just moments away from the natural beauty of Maidu Regional Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maidu Regional Park",
      "seo_description": "Discover Sierra Glen in Citrus Heights, offering modern living near Maidu Regional Park, with amenities like high-speed internet and a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "citrus-heights-apartments-near-rusch-park",
      "search_query": "Citrus Heights apartments close to Rusch Community Park",
      "category": "Park",
      "h1_title": "Citrus Heights Apartments Near Rusch Park",
      "h2_subtitle": "Discover comfort at Sierra Glen, located close to Rusch Community Park. Enjoy outdoor activities paired with modern apartment living in Citrus Heights.",
      "page_copy": "Sierra Glen is perfectly positioned for those who love being near nature and enjoying outdoor activities, with its location close to Rusch Community Park in Citrus Heights. Our community offers a serene environment combined with the convenience of nearby park amenities.\n\nOur Citrus Heights apartments feature high-speed internet access, a smoke-free environment, and cozy fireplaces, which make coming home to Sierra Glen a pleasure. After a day at the park, unwind by our inviting pool or enjoy the peaceful ambiance of our surroundings. Sierra Glen offers not just a place to live but a gateway to a vibrant lifestyle balanced between outdoor fun and home comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Citrus Heights Apts Near Rusch Community Park",
      "seo_description": "Live at Sierra Glen in Citrus Heights, where modern apartments meet outdoor adventures at nearby Rusch Community Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "harry-crabb-park-nearby-apartments-sacramento",
      "search_query": "Harry Crabb Park nearby apartments in Sacramento County",
      "category": "Park",
      "h1_title": "Harry Crabb Park Nearby Apartments",
      "h2_subtitle": "Sierra Glen offers prime apartment living near Harry Crabb Park. Enjoy the perfect mix of nature and convenience in Sacramento County.",
      "page_copy": "Sierra Glen presents an ideal living option for those who wish to stay close to nature with its proximity to Harry Crabb Park in Sacramento County. Our community ensures residents have easy access to lush green spaces while enjoying the comforts of a modern apartment.\n\nAt Sierra Glen, we provide amenities such as high-speed internet access and a smoke-free environment, creating a healthy and tech-savvy living experience. Cozy fireplaces add a touch of warmth, while our swimming pool offers a refreshing escape during warm days. Nestled near Harry Crabb Park, Sierra Glen allows you to take full advantage of outdoor activities while enjoying the luxuries of contemporary living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harry Crabb Park, Sacramento",
      "seo_description": "Find modern living at Sierra Glen, near Harry Crabb Park in Sacramento County, offering amenities like high-speed internet and a relaxing pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "apartments-by-johnson-springview-park",
      "search_query": "apartments by Johnson-Springview Park CA",
      "category": "Park",
      "h1_title": "Apartments by Johnson-Springview Park",
      "h2_subtitle": "Experience living at Sierra Glen, conveniently located by Johnson-Springview Park, CA. Enjoy comfort and community in this prime location.",
      "page_copy": "Nestled in a prime location, Sierra Glen offers you the perfect blend of comfort and convenience just moments away from Johnson-Springview Park, CA. Embrace a lifestyle that keeps you close to beautiful landscapes and community festivities.\n\nSierra Glen provides a smoke-free environment and high-speed internet access, ensuring a comfortable and connected living experience. Our apartments feature cozy fireplaces for those cool evenings and a refreshing swimming pool for sunnier days. Experience the advantages of a vibrant community atmosphere with easy access to the recreational opportunities at Johnson-Springview Park, all from the comfort of your home at Sierra Glen.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Johnson-Springview Park, CA",
      "seo_description": "Live at Sierra Glen, offering comfortable apartments near Johnson-Springview Park, CA with amenities like a pool and high-speed internet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166906",
      "source": "generator",
      "page_item_url": "gibson-ranch-regional-park-apartments",
      "search_query": "Gibson Ranch Regional Park nearby Citrus Heights apartments",
      "category": "Park",
      "h1_title": "Citrus Heights Apts Near Gibson Ranch Park",
      "h2_subtitle": "Discover Sierra Glen, offering Citrus Heights apartments conveniently near Gibson Ranch Regional Park. Blend nature with modern living effortlessly.",
      "page_copy": "Sierra Glen provides an exceptional living experience with its ideal location near Gibson Ranch Regional Park in Citrus Heights. Our community is perfect for those who seek both outdoor adventures and modern apartment comforts.\n\nFeaturing amenities such as high-speed internet access, cozy fireplaces, and a smoke-free environment, Sierra Glen ensures a well-rounded lifestyle. Relax by the pool or enjoy the warmth of your home after a day exploring the vast trails and natural beauty of Gibson Ranch Regional Park. Discover how life at Sierra Glen can offer you the serene balance between nature and modern conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Citrus Heights Apartments Near Gibson Ranch Park",
      "seo_description": "Live at Sierra Glen, where Citrus Heights apartments meet the beauty of Gibson Ranch Regional Park, offering comfort and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5962"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372415108"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-59D5RV2L"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-717-8912 "
    }
  ],
  "custom_qb_id": "5962",
  "custom_repli_id": "18372415108",
  "custom_google_gtm_id": "\tGTM-59D5RV2L",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-717-8912 "
};

export const generatedAt = '2026-09-25T15:49:53.071Z';
